import React from "react";
import Layout from "components/Layout/Layout";

const Details = (props) => {
    return <Layout>{props.match.params.key}</Layout>;
};

export default Details;
